function formatTime(date) {
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
   
    var hour = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()
   
    //return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
    return [year, month, day].map(formatNumber).join('') + '' + [hour, minute, second].map(formatNumber).join('')
  }
   
  function formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  }
   
  //此处声明几个方法就写几个,如上面定义了formatTime 写法如下
  module.exports = {
    formatTime: formatTime 
  }